module.exports = __webpack_public_path__ + "static/media/file-icon-white.5cced1fe.svg";